export class MedicalConditionItem {
    medical_condition_id?: string = "";
    medical_condition_name: string = "";
    is_reportable : boolean = false;
    is_adi : boolean = false;
    
}